import { useState, useEffect } from "react";
import { ListRoles } from "../../../components/Admin/Roles";
import "./Roles.scss";
import { useAuth } from "../../../hooks";
import { Permission } from "../../../api";
import { isAdmin, hasPermission, isMaster } from "../../../utils/checkPermission";
import { ErrorAccessDenied } from "../Error";
import { useLanguage } from "../../../contexts";

const permissionController = new Permission();

export function Roles() {
  const [reload, setReload] = useState(false);

  const {
    accessToken,
    user: { role },
  } = useAuth();

  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const onReload = () => setReload((prevState) => !prevState);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getPermissionsByRole(
            accessToken,
            role._id,
            true,
          );
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  if (
    isMaster(role) ||
    isAdmin(role) ||
    hasPermission(permissionsByRole, role._id, "roles", "view")
  ) {
    return (
      <div className="role-forms-page">
        <div className="role-page-header-wrapper">
          <div className="role-page-header">
            <span className="role-page-title">{t("role")}</span>
          </div>
        </div>

        <ListRoles reload={reload} onReload={onReload} />
      </div>
    );
  } else {
    return <ErrorAccessDenied />;
  }
}
